module.exports = __webpack_public_path__ + "prod/1.42.2/img/seal.08bf9ffa.png";